import { loadState, saveState } from "../vue-caas/utils/idb";

export default function createIDBPersist({
  key = 'my-vuex',
  paths = [],
  reducer = null,
} = {}) {
  return async (store) => {
    const savedState = await loadState(key);

    if (savedState) {
      store.replaceState({
        ...store.state,
        ...savedState
      });
    }

    store.subscribe(async (mutation, state) => {
      let data = state;
      if (paths.length) {
        data = {};
        paths.forEach(p => {
          data[p] = state[p];
        });
      }

      if (reducer) {
        data = reducer(state);
      }

      await saveState(key, data);
    });
  };
}